<flat-header
  *ngIf="configurationService.isTabletOrLarger$ | async"
  headerText="saleModule.yourOrder"
></flat-header>

<div class="container-lg main-container p-0 overflow-hidden">
  <div class="mb-6" *ngIf="sale?.statusCode == SaleStatusCode.DONE">
    <section class="card text-center shadow-none">
      <div class="card-header bg-success text-center">
        <h3
          *ngIf="!(saleRequiresApproval$ | async)"
          class="card-title h2"
          data-test-id="sale-completed-text"
        >
          <span *ngIf="orderCompletedTitle$ | async as orderCompletedTitle">
            <span [innerHTML]="orderCompletedTitle | safeHtml"></span>
          </span>
          <span *ngIf="!(orderCompletedTitle$ | async)">
            {{ 'saleModule.orderCompleted' | translate }}
          </span>
        </h3>
        <h3 *ngIf="saleRequiresApproval$ | async" class="card-title h2">
          {{ 'paymentModule.bookingRequestSent' | translate }}
        </h3>
      </div>
      <div class="card-body">
        <i
          class="fa fa-check-circle m-4 fa-2x text-success"
          aria-hidden="true"
          role="img"
        ></i>
        <ng-container *ngIf="!(saleRequiresApproval$ | async)">
          <h3 class="text-success h4" role="alert">
            <span
              *ngIf="orderCompletedSubtitle$ | async as orderCompletedSubtitle"
            >
              <span [innerHTML]="orderCompletedSubtitle | safeHtml"></span>
            </span>
            <span *ngIf="!(orderCompletedSubtitle$ | async)">
              {{ 'saleModule.orderCompletedSubtitle' | translate }}
            </span>
          </h3>

          <button
            type="button"
            *ngIf="showAddToCalendarButton"
            class="btn btn-primary d-block mx-auto"
            (click)="getIcalDownload()"
          >
            <i
              class="fa fa-calendar-plus me-2"
              aria-hidden="true"
              role="img"
            ></i>
            <span>{{ 'bookingModule.addToCalendar' | translate }}</span>
          </button>
        </ng-container>

        <ng-container *ngIf="saleRequiresApproval$ | async">
          <h4 data-test-id="waiting-for-approval" role="alert">
            {{ 'bookingModule.waitingForApproval' | translate }}
          </h4>
        </ng-container>

        <button
          type="button"
          class="btn btn-primary mt-3 d-block mx-auto"
          (click)="onClickSchedule()"
          data-test-id="bookings-sale-button-go-to-home"
        >
          {{ homeNavigationTitle$ | async | translate }}
        </button>
      </div>
    </section>
  </div>

  <div class="mb-6" *ngIf="params?.status == 'failure'">
    <section class="card shadow-none">
      <div class="card-header bg-warning">
        <h2 class="mb-0">
          {{ 'paymentModule.paymentFailed' | translate }}
        </h2>
      </div>
      <div class="card-body text-center">
        <div class="m-4 text-center">
          <i class="fa fa-times-circle fs-2" aria-hidden="true" role="img"></i>
        </div>
        <button
          *ngIf="this.sale?.id"
          type="button"
          class="btn btn-primary"
          (click)="onClickRetryPayment()"
        >
          {{ 'general.retry' | translate }}
        </button>
      </div>
    </section>
  </div>
  <section class="card shadow-none" [hidden]="params?.status == 'failure'">
    <div class="card-header">
      <h3 class="card-title">{{ 'saleModule.yourOrder' | translate }}</h3>
    </div>
    <div class="card-body">
      <sale-item-table-card
        *ngIf="(sale$ | async) && (saleItems$ | async)"
        [sale]="sale$ | async"
        [saleItems$]="saleItems$"
      >
      </sale-item-table-card>

      <payments-table [payments]="payments"></payments-table>

      <div class="row mt-3">
        <div class="col-sm-2">
          <h4 class="mb-0">{{ 'paymentModule.payment' | translate }}</h4>
        </div>
        <div class="col">
          <h4
            class="text-success"
            *ngIf="
              params?.status == 'success' &&
              sale?.statusCode != SaleStatusCode.DONE
            "
          >
            {{ 'paymentModule.paymentPending' | translate }}
          </h4>

          <h4
            class="text-success"
            *ngIf="sale?.statusCode == SaleStatusCode.DONE"
            ><span
              *ngIf="params?.paymentMethod == PayMethodType.PAY_METHOD_INVOICE"
              >{{ 'paymentModule.paymentByInvoice' | translate }}</span
            >
            <span
              *ngIf="params?.paymentMethod != PayMethodType.PAY_METHOD_INVOICE"
              >{{ 'paymentModule.paymentSuccess' | translate }}</span
            >
          </h4>

          <h4 class="text-danger" *ngIf="params?.status == 'failure'">
            {{ 'paymentModule.paymentFailureCallback' | translate }}
          </h4>
        </div>
      </div>

      <h4 class="text-center" *ngIf="sale?.statusCode != SaleStatusCode.DONE">
        <h4 class="text-success" *ngIf="params?.status == 'success'">
          {{
            'paymentModule.paymentSuccessCallbackAwaitingConfirmation'
              | translate
          }}
        </h4>
        <h4 class="text-danger" *ngIf="params?.status == 'failure'">
          {{ 'paymentModule.paymentFailureCallback' | translate }}
        </h4>
        <div
          class="spinner-border"
          role="status"
          attr.aria-label="{{ 'wcag.loading' | translate }}"
        >
        </div>
      </h4>
    </div>
  </section>

  <div *ngIf="sale">
    <div
      class="col-12 col-sm col-md d-flex justify-content-center order-4 m-4"
      *ngIf="sale?.statusCode == SaleStatusCode.DONE"
    >
      <button
        *ngIf="!(memberIsGuest$ | async) && member"
        data-test-id="sale-detail-page-button"
        type="button"
        class="btn btn-soft-primary"
        (click)="onClickSaleDetailButton()"
      >
        {{ 'general.details' | translate }}
      </button>

      <button
        *ngIf="
          sale?.statusCode == SaleStatusCode.DONE &&
          (saleService.isTicketSale$(sale) | async) &&
          !sale?.isCreditOfSaleId &&
          saleDocuments?.length &&
          showDownloadTicketsButton &&
          activeTicketingBlockModule
        "
        data-test-id="sale-callback-download-tickets-button"
        type="button"
        class="btn btn-soft-primary"
        (click)="onClickDownloadTicket()"
      >
        {{ 'general.downloadTicket' | translate }}
      </button>
    </div>
  </div>
</div>
